export default {
  strict: true,
  namespaced: true,
  state: {
    hasRegistration: false,
    hasConsent: false,
    registrationId: null,
    testType: null,
    state: null,
    facility: null,
    company: null,
    extendedTime: false,
    reasonForExtension: null,
    language: null,
    testNumber: null,
  },
  getters: {
    hasRegistration: state => state.hasRegistration,
    hasConsent: state => state.hasConsent,
    registration: state => {
      const registration = {
        registrationId: state.registrationId,
        testType: state.testType,
        state: state.state,
        facility: state.facility,
        company: state.company,
        extendedTime: state.extendedTime,
        reasonForExtension: state.reasonForExtension,
        language: state.language,
        testNumber: state.testNumber,
      };

      return registration;
    },
  },
  mutations: {
    saveRegistration: (state, payload) => {
      state.hasRegistration = true;
      state.registrationId = payload.registrationId;
      state.testType = payload.testType;
      state.state = payload.state;
      state.facility = payload.facility;
      state.company = payload.company;
      state.extendedTime = payload.extendedTime;
      state.reasonForExtension = payload.reasonForExtension;
      state.language = payload.language;
      state.testNumber = payload.testNumber;
    },
    saveConsent: state => (state.hasConsent = true),
  },
  actions: {
    saveRegistration: (context, payload) => context.commit("saveRegistration", payload),
    saveConsent: context => context.commit("saveConsent"),
  },
};
